import styled from 'styled-components';

export const HotWord = styled.div``;

export const List = styled.div`
  display: flex;
  padding: 10px 20px;
  box-sizing: border-box;

  > .hot-word {
    display: block;

    font-size: 12px;
    font-family: PingFangSC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1;

    &:not(:first-child) {
      margin-left: 20px;
    }

    &:hover {
      color: rgba(232, 45, 75, 1);
    }
  }
`;
